import React from 'react'

const Industries = () => {
    return (
        <div>
            <h1>Industries</h1>
        </div>
    )
}

export default Industries